import { Component } from "../bootstrap/component";
import { tns, TinySliderInstance } from 'tiny-slider/src/tiny-slider'
import { PAGE } from "../bootstrap/elements";
import { getElement, getElementID, getElements } from "./DOM";
import { scroll } from "../app";
import * as PDFJS from 'pdfjs-dist';

export class PDFReader extends Component {
  private elements: {
    reader: HTMLElement;
    title: HTMLElement;
    category: HTMLElement;
    pagesCount: HTMLElement;
    activePageIndex: HTMLElement;
    navigationContent: HTMLElement;
    navContent: HTMLElement;
    sidebarScroll: HTMLElement;
    activeLibraryNavigation?: HTMLElement;
    libraryNavigation?: NodeListOf<HTMLElement>;
    navigationItems?: NodeListOf<HTMLElement>;
    pdfWrapper: HTMLElement;
  }

  private activePDF: PDFJS.PDFDocumentProxy;
  private activePdfFile: string;
  private activePageNumber: number;
  private navigationSlider: TinySliderInstance;
  private clickNavigationListener: EventListenerOrEventListenerObject;

  constructor() {
    super();
  }

  public async onInit() {
    const reader = getElementID('reader');

    if (!reader) {
      return false;
    }

    PDFJS.GlobalWorkerOptions.workerSrc = 'scripts/pdf.worker.min.js';

    this.elements = {
      reader,
      title: getElementID('readerTitle'),
      category: getElementID('readerCategory'),
      pagesCount: getElementID('readerPagesCount'),
      activePageIndex: getElementID('readerActivePageIndex'),
      navigationContent: getElementID('readerNavigation'),
      navContent: getElementID('readerNav'),
      sidebarScroll: getElementID('sidebarScroll'),
      pdfWrapper: getElementID('readePdfWrapper'),
    }

    // Navigation controls
    const controls = getElements('[data-pdfcontrol]');
    controls.forEach(control => {
      const { pdfcontrol } = control.dataset;

      control.addEventListener('click', () => {
        this.goToPage(this.activePageNumber + Number(pdfcontrol));
      });
    });

    // Check active PDF reader
    this.elements.activeLibraryNavigation = getElement('.navigation-expand__item.isActive');
    if (this.elements.activeLibraryNavigation) {
      const { file, title, category, pagescount } = this.elements.activeLibraryNavigation.dataset;

      this.openPdf({
        file,
        title,
        category,
        pagesCount: Number(pagescount)
      });
    }

    // Library navigation
    // No need to remove listener
    this.elements.libraryNavigation = getElements('[data-file]');
    this.elements.libraryNavigation.forEach(button => {
      const { file, title, category, pagescount } = button.dataset;

      button.addEventListener('click', () => {
        if (button.classList.contains('isActive')) {
          return
        }

        if (this.elements.activeLibraryNavigation) {
          this.elements.activeLibraryNavigation.classList.remove('isActive');
        }

        this.openPdf({
          title,
          file,
          category,
          pagesCount: Number(pagescount)
        });

        button.classList.add('isActive');
        this.elements.activeLibraryNavigation = button;
      });
    });

    // Toggle focus
    const elements = document.querySelectorAll('.reader__close, .navigation-expand__item');
    elements.forEach(element => {
      element.addEventListener('click', () => {
        PAGE.classList.toggle('hasReaderFocus');

        window.scrollTo(0, 0);
      })
    });

    // Open PDF
    const activePdfFile = window.location.search.substring(1);
    if (activePdfFile) {
      const link = getElement(`[data-file*="${activePdfFile}"]`);

      if (!link) {
        return;
      }

      const button = link.closest('.navigation-expand').previousElementSibling as HTMLElement;

      link.click();
      button.click();

      scroll.to({
        targetElement: button,
        time: 200,
        scrollingElement: this.elements.sidebarScroll
      });
    } else {
      // Don't render pdf for small viewport
      if (window.matchMedia(`(max-width: 1024px)`).matches) {
        return;
      }

      getElement('.navigation__link', this.elements.sidebarScroll).click();
      getElement('.navigation-expand__item', this.elements.sidebarScroll).click();
    }
  }

  public async createNavigation(pagesCount: number) {
    this.elements.navContent.classList.add('isLoading');

    if (!pagesCount) {
      return;
    }

    for (let index = 0; index < pagesCount; index++) {
      const template = `<div class="reader-navigation__item-wrapper"><button type="button" class="reader-navigation__item" data-pdf-goto="${index + 1}"><img data-src="/fl-intervention/images/pdf-reader-thumbnail/${this.activePdfFile}/${index + 1}.jpg"></div>`;

      this.elements.navigationContent.insertAdjacentHTML('beforeend', template);

      const buttonElement = this.elements.navigationContent.lastElementChild.querySelector('.reader-navigation__item') as HTMLElement;

      buttonElement.addEventListener('click', this.clickNavigationListener = () => {
        if (!this.activePDF) {
          return;
        }

        const value = Number(buttonElement.getAttribute('data-pdf-goto'));

        if (value === this.activePageNumber) {
          return;
        }

        this.goToPage(value);
      });
    };

    this.elements.navigationItems = getElements('[data-pdf-goto]');
    const activeNavigationItem = this.elements.navigationItems[this.activePageNumber - 1]

    if (activeNavigationItem) {
      activeNavigationItem.classList.add('isActive');
    }

    this.elements.navigationItems.forEach(navigation => {
      navigation.addEventListener('click', this.clickNavigationListener = () => {
        const value = Number(navigation.getAttribute('data-pdf-goto'));

        if (value === this.activePageNumber) {
          return;
        }

        this.goToPage(value);
      });
    });

    // Slider navigation
    this.navigationSlider = tns({
      loop: false,
      container: document.getElementById('readerNavigation'),
      mouseDrag: false,
      autoplay: false,
      controls: false,
      nav: false,
      lazyload: true,
      edgePadding: 50,
      items: 3,
      // @ts-ignore
      center: false,
      responsive: {
        0: {
          items: 3,
        },
        500: {
          items: 5,
        },
        768: {
          items: 8,
        },
        1024: {
          items: 9,
        },
        1200: {
          items: 12,
        },
        1400: {
          items: 14,
        }
      },
    });

    this.elements.navContent.classList.remove('isLoading');
  }

  public destroyNavigation() {
    if (!this.navigationSlider) {
      return
    }

    this.navigationSlider.destroy();

    this.navigationSlider = null;

    this.elements.navigationContent = document.getElementById('readerNavigation');

    this.elements.navigationItems.forEach(navigation => {
      navigation.removeEventListener('click', this.clickNavigationListener);
    });

    this.elements.navigationContent.innerHTML = '';
  }

  public async openPdf(params: {
    title: string,
    category: string,
    file: string,
    pagesCount: number
  }) {
    this.activePDF = null;
    this.elements.pdfWrapper.classList.add('isLoading');
    this.elements.reader.classList.add('isLoading');

    if (this.navigationSlider) {
      this.destroyNavigation();
    }

    const { title, file, category, pagesCount } = params;

    this.activePdfFile = file;

    this.elements.title.innerText = title;
    this.elements.category.innerText = category;
    this.elements.pagesCount.innerText = String(pagesCount);

    this.createNavigation(pagesCount);

    await PDFJS.getDocument(`./pdf/${file}.pdf`).promise.then(pdf => this.activePDF = pdf);

    this.goToPage(1);

    this.elements.reader.classList.remove('isLoading');
  }

  public goToPage(value: number) {
    if (!value) {
      return;
    }

    if (this.elements.navigationItems && this.elements.navigationItems.length < value) {
      return;
    }

    this.elements.pdfWrapper.classList.add('isLoading');

    if (this.activePageNumber) {
      this.elements.navigationItems[this.activePageNumber - 1].classList.remove('isActive');
    }

    this.activePDF.getPage(value).then(async (page) => {
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;
      canvas.classList.add('reader__canvas');

      const renderContext: PDFJS.PDFRenderParams = {
        canvasContext: context,
        viewport: viewport,
      };

      await page.render(renderContext).promise.then(() => {
        const { pdfWrapper } = this.elements;

        pdfWrapper.innerHTML = null;
        pdfWrapper.appendChild(canvas);
        pdfWrapper.classList.remove('isLoading');
      });

      this.activePageNumber = value;
      this.elements.activePageIndex.innerText = value.toString();

      if (!this.elements.navigationItems) {
        return;
      }

      this.elements.navigationItems[this.activePageNumber - 1].classList.add('isActive');

      if (!this.navigationSlider) {
        return;
      }

      this.navigationSlider.goTo(this.activePageNumber - 1);
    });
  }
} 